import React from "react";


import Tabs from "./components/Tabs";

var def = {
    ID: "05 OM6 15K-30K (6)",
    Type: "R",
    Game: "Pot Limit Omaha-6",
    Seats: 6,
    addInPot: false,
    alone: false,
    Players: {
        1: {
            Player: "",
            Status: "empty",
            Chips: 0,
            Seat: 1,
            CLType: false,
            Action: 15,
            Helper: "",
            cardDeal: false,
            Cards: [0, 0, 0, 0, 0],
            CCards: "",
            place: -1,
            point: -1,
            inPot: [0, 0, 0, 0],
            state: 0,
            sitingOut: false,
            handpoint: -1,
            _handlimit: 0,
            _timelimit: 0,
            _startplay: 0,
            _played: 0,
            _deciding: false,
        },
        2: {
            Player: "",
            Status: "empty",
            Chips: 0,
            Seat: 2,
            CLType: false,
            Action: 15,
            Helper: "",
            cardDeal: false,
            Cards: [0, 0, 0, 0, 0],
            CCards: "",
            place: -1,
            point: -1,
            inPot: [0, 0, 0, 0],
            state: 0,
            sitingOut: false,
            handpoint: -1,
            _handlimit: 0,
            _timelimit: 0,
            _startplay: 0,
            _played: 0,
            _deciding: false,
        },
        3: {
            Player: "",
            Status: "empty",
            Chips: 0,
            Seat: 3,
            CLType: false,
            Action: 15,
            Helper: "",
            cardDeal: false,
            Cards: [0, 0, 0, 0, 0],
            CCards: "",
            place: -1,
            point: -1,
            inPot: [0, 0, 0, 0],
            state: 0,
            sitingOut: false,
            handpoint: -1,
            _handlimit: 0,
            _timelimit: 0,
            _startplay: 0,
            _played: 0,
            _deciding: false,
        },
        4: {
            Player: "Django",
            Status: "playing",
            Chips: 570000,
            Seat: 4,
            CLType: "Bot",
            Action: 0,
            Helper: "Two Pair, Fours and Twos +9",
            cardDeal: false,
            Cards: ["5d", "4h", "5s", "8d", "3c", "2d"],
            CCards: "",
            place: -1,
            point: -1,
            inPot: [30000, 0, 0, 0],
            state: 0,
            sitingOut: false,
            handpoint: -1,
            _handlimit: 0,
            _timelimit: 0,
            _startplay: 0,
            _played: 0,
            _deciding: false,
            buttons: {
                Command: "Buttons",
                Table: "05 OM6 15K-30K (6)",
                Type: "R",
                Button1: "Fold",
                Button2: "Check",
                Button3: "Bet",
                Button4: "",
                Preflop: "No",
                BringIn: 0,
                Call: 0,
                MinRaise: 30000,
                MaxRaise: 58020,
                IncRaise: 30000,
                Multiple: 1,
                BB: 30000,
                Bet: 0,
                Pot: 58020,
                TimeBank: 24,
            },
            dobutton: [],
        },
        5: {
            Player: "",
            Status: "empty",
            Chips: 0,
            Seat: 5,
            CLType: false,
            Action: 15,
            Helper: "",
            cardDeal: false,
            Cards: [0, 0, 0, 0, 0],
            CCards: "",
            place: -1,
            point: -1,
            inPot: [0, 0, 0, 0],
            state: 0,
            sitingOut: false,
            handpoint: -1,
            _handlimit: 0,
            _timelimit: 0,
            _startplay: 0,
            _played: 0,
            _deciding: false,
        },
        6: {
            Player: "KyloRen",
            Status: "playing",
            Chips: 570000,
            Seat: 6,
            CLType: "Bot",
            Action: 0,
            Helper: "Pair of Fours +A97",
            cardDeal: false,
            Cards: ["3s", "ah", "3d", "qh", "6c", "4c"],
            CCards: "",
            place: -1,
            point: -1,
            inPot: [30000, 0, 0, 0],
            state: 0,
            sitingOut: false,
            handpoint: -1,
            _handlimit: 0,
            _timelimit: 0,
            _startplay: 0,
            _played: 0,
            _deciding: false,
            buttons: {
                Command: "Buttons",
                Table: "05 OM6 15K-30K (6)",
                Type: "R",
                Button1: "Fold",
                Button2: "Check",
                Button3: "Bet",
                Button4: "",
                Preflop: "No",
                BringIn: 0,
                Call: 0,
                MinRaise: 30000,
                MaxRaise: 58020,
                IncRaise: 30000,
                Multiple: 1,
                BB: 30000,
                Bet: 0,
                Pot: 58020,
                TimeBank: 24,
            },
            dobutton: [],
        },
    },
    state: 2,
    flopCards: ["4s", "7h", "9h", "2s"],
    total: 58020,
    Call: 0,
    Player: "Django",
    Helper: "Two Pair, Fours and Twos +9",
    convertedCards: ["5d", "4h", "5s", "8d", "3c", "2d"],
    pot: 0,
    calculated: false,
    SB: 15000,
    BB: 30000,
    BuyinMin: 600000,
    BuyinMax: 3000000,
    handnumber: "#8904641-1",
    dealed: true,
    _seted: false,
    allCards: ["5d", "4h", "5s", "8d", "3c", "2d", "3s", "ah", "3d", "qh", "6c", "4c", "4s", "7h", "9h", "2s"],
    allBots: true,
    _players: {
        4: {
            Player: "Django",
            Seat: 4,
            Status: "playing",
            Chips: 600000,
            Bot: true,
            Cards: [0, 0, 0, 0, 0],
            buttons: {
                Command: "Buttons",
                Table: "05 OM6 15K-30K (6)",
                Type: "R",
                Button1: "",
                Button2: "Start",
                Button3: "",
                Button4: "",
                Preflop: "No",
                BringIn: 0,
                Call: 0,
                MinRaise: 0,
                MaxRaise: 0,
                IncRaise: 0,
                Multiple: 0,
                BB: 0,
                Bet: 0,
                Pot: 0,
                TimeBank: 0,
            },
            Helper: "",
            inPot: [30000, 0, 0, 0],
        },
        6: {
            Player: "KyloRen",
            Seat: 6,
            Status: "playing",
            Chips: 600000,
            Bot: true,
            Cards: [0, 0, 0, 0, 0],
            buttons: {
                Command: "Buttons",
                Table: "05 OM6 15K-30K (6)",
                Type: "R",
                Button1: "",
                Button2: "Start",
                Button3: "",
                Button4: "",
                Preflop: "No",
                BringIn: 0,
                Call: 0,
                MinRaise: 0,
                MaxRaise: 0,
                IncRaise: 0,
                Multiple: 0,
                BB: 0,
                Bet: 0,
                Pot: 0,
                TimeBank: 0,
            },
            Helper: "",
            inPot: [30000, 0, 0, 0],
        },
    },
    hotSeat: {
        seat: 4,
        buttons: {
            Button1: false,
            Button2: false,
            Button3: false,
            Button4: false,
        },
    },
    ranks: {
        1: [
            {
                username: "Django",
                percent: 59,
            },
        ],
        2: [
            {
                username: "KyloRen",
                percent: 41,
            },
        ],
    },
    odds: {
        summary: [
            {
                username: "Django",
                odds: 65.28,
            },
            {
                username: "KyloRen",
                odds: 34.72,
            },
        ],
        details: [
            {
                futureCards: ["2h"],
                winners: [
                    {
                        username: "Django",
                        handBreakdown: [
                            {
                                name: "Full House",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Full House, 2s full of 4s",
            },
            {
                futureCards: ["kh"],
                winners: [
                    {
                        username: "KyloRen",
                        handBreakdown: [
                            {
                                name: "Flush",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Flush, AceKingQueen97",
            },
            {
                futureCards: ["as"],
                winners: [
                    {
                        username: "Django",
                        handBreakdown: [
                            {
                                name: "Straight",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Straight, 5-high",
            },
            {
                futureCards: ["5c"],
                winners: [
                    {
                        username: "KyloRen",
                        handBreakdown: [
                            {
                                name: "Straight",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Straight, 5-high",
            },
            {
                futureCards: ["5h"],
                winners: [
                    {
                        username: "KyloRen",
                        handBreakdown: [
                            {
                                name: "Flush",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Flush, AceQueen975",
            },
            {
                futureCards: ["4d"],
                winners: [
                    {
                        username: "Django",
                        handBreakdown: [
                            {
                                name: "Full House",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Full House, 4s full of 2s",
            },
            {
                futureCards: ["as"],
                winners: [
                    {
                        username: "Django",
                        handBreakdown: [
                            {
                                name: "Straight",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Straight, 5-high",
            },
            {
                futureCards: ["ks"],
                winners: [
                    {
                        username: "Django",
                        handBreakdown: [
                            {
                                name: "Two Pair",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Two Pair, 4s and 2s +7",
            },
            {
                futureCards: ["ks"],
                winners: [
                    {
                        username: "Django",
                        handBreakdown: [
                            {
                                name: "Two Pair",
                                isBest: true,
                            },
                        ],
                    },
                ],
                hand: "Two Pair, 4s and 2s +7",
            },
        ],
    },
    amounts: {
        BB: 30000,
    },
    mySeats: [
        {
            Player: "Django",
            Status: "playing",
            Chips: 570000,
            Seat: 4,
            CLType: "Bot",
            Action: 0,
            Helper: "Two Pair, Fours and Twos +9",
            cardDeal: false,
            Cards: ["5d", "4h", "5s", "8d", "3c", "2d"],
            CCards: "",
            place: -1,
            point: -1,
            inPot: [30000, 0, 0, 0],
            state: 0,
            sitingOut: false,
            handpoint: -1,
            _handlimit: 0,
            _timelimit: 0,
            _startplay: 0,
            _played: 0,
            _deciding: false,
            buttons: {
                Command: "Buttons",
                Table: "05 OM6 15K-30K (6)",
                Type: "R",
                Button1: "Fold",
                Button2: "Check",
                Button3: "Bet",
                Button4: "",
                Preflop: "No",
                BringIn: 0,
                Call: 0,
                MinRaise: 30000,
                MaxRaise: 58020,
                IncRaise: 30000,
                Multiple: 1,
                BB: 30000,
                Bet: 0,
                Pot: 58020,
                TimeBank: 24,
            },
            dobutton: [],
        },
        {
            Player: "KyloRen",
            Status: "playing",
            Chips: 570000,
            Seat: 6,
            CLType: "Bot",
            Action: 0,
            Helper: "Pair of Fours +A97",
            cardDeal: false,
            Cards: ["3s", "ah", "3d", "qh", "6c", "4c"],
            CCards: "",
            place: -1,
            point: -1,
            inPot: [30000, 0, 0, 0],
            state: 0,
            sitingOut: false,
            handpoint: -1,
            _handlimit: 0,
            _timelimit: 0,
            _startplay: 0,
            _played: 0,
            _deciding: false,
            buttons: {
                Command: "Buttons",
                Table: "05 OM6 15K-30K (6)",
                Type: "R",
                Button1: "Fold",
                Button2: "Check",
                Button3: "Bet",
                Button4: "",
                Preflop: "No",
                BringIn: 0,
                Call: 0,
                MinRaise: 30000,
                MaxRaise: 58020,
                IncRaise: 30000,
                Multiple: 1,
                BB: 30000,
                Bet: 0,
                Pot: 58020,
                TimeBank: 24,
            },
            dobutton: [],
        },
    ],
};
//def = JSON.parse(localStorage.getItem("def"))
const BlackjackGame = () => {

   

        return (
            <div>
                <Tabs/>
               
            </div>
        );
   
   
};

export default BlackjackGame;
